import { Box, IconButton, Typography, Paper } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';


export default function QuantitySelector({ minQuantity, maxQuantity, handleDecrement, handleIncrement, quantity }) {

return (
    <Paper
        elevation={0}
        sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1,
            borderRadius: 2,
            bgcolor: 'background.paper',
        }}
    >
        <Paper
            elevation={3}
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                borderRadius: 2,
                bgcolor: 'background.paper',
            }}
        >
            <IconButton
                onClick={handleDecrement}
                disabled={quantity <= minQuantity}
                aria-label="decrease quantity"
                color="text.primary"
                sx={{
                    borderRadius: 1,
                }}
            >
                <RemoveIcon />
            </IconButton>
        </Paper>

        <Box sx={{ textAlign: 'center',  px: .5 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                Quantity
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
                {quantity}
            </Typography>
        </Box>

        <Paper
            elevation={3}
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                borderRadius: 2,
                bgcolor: 'background.paper',
            }}
        >
            <IconButton
                onClick={handleIncrement}
                disabled={quantity >= maxQuantity}
                aria-label="increase quantity"
                color="text.primary"
                size='large'
                sx={{
                    borderRadius: 1,
                }}
            >
                <AddIcon />
            </IconButton>
        </Paper>
    </Paper>
);
}